import { render } from "./MyVendorCode4User.vue?vue&type=template&id=1fcdaa11&scoped=true"
import script from "./MyVendorCode4User.vue?vue&type=script&lang=js"
export * from "./MyVendorCode4User.vue?vue&type=script&lang=js"

import "./MyVendorCode4User.vue?vue&type=style&index=0&id=1fcdaa11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcdaa11"]])

export default __exports__